import { render, staticRenderFns } from "./ActivityType.vue?vue&type=template&id=abf8d0f0&scoped=true&"
import script from "./ActivityType.vue?vue&type=script&lang=js&"
export * from "./ActivityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf8d0f0",
  null
  
)

export default component.exports